let utils = require( './utils' );

let ocm_submenu = ( function( $ ) {

	let $ocm;

	let _init = function() {
		$ocm = $( '#off-canvas-menu' );

		_setup_submenu_triggers();
	};

	let _setup_submenu_triggers = function() {
		let submenu_triggers = $ocm.find( 'ul li.menu-item-has-children' );

		submenu_triggers.each( function() {
			$( this ).find( 'a' ).first().on( 'click', function( e ) {
				let $parent_li = $( this ).closest( 'li.menu-item-has-children' );

				e.preventDefault();

				if ( ! $parent_li.hasClass( 'open-submenu' ) ) {
					$parent_li.addClass( 'open-submenu' );
					_open_submenu( $parent_li.find( 'ul.sub-menu' ) );
				} else  {
					$parent_li.removeClass( 'open-submenu' );
					_close_submenu( $parent_li.find( 'ul.sub-menu' ) );
				}
			} );
		} );
	};

	let _open_submenu = function( $submenu ) {
		$submenu.slideDown();
	};
	
	let _close_submenu = function( $submenu ) {
		$submenu.slideUp();
	};

	$( document ).ready( _init );

	return {};

} )( jQuery );

module.exports = ocm_submenu;